import { Theme, ThemeProvider } from "@mui/material";
import { confirmable, ConfirmDialog, createConfirmation } from "react-confirm";

import { DeleteConfirmation } from "@/Components/v2/molecule/ConfirmationDialog";

interface ConfirmationProps {
  title?: string;
  subtitle?: string;
  deleteButtonText?: string;
  cancelButtonText?: string;
  theme: Theme;
}

const ResetScenarioConstraintsDialog: ConfirmDialog<ConfirmationProps, boolean> = ({
  show,
  proceed,
  title = "Reset all channel constraints",
  subtitle = "Are you sure you want to delete all channel constraints on this scenario? This cannot be undone.",
  deleteButtonText = "Reset Constraints",
  cancelButtonText = "Cancel",
  theme,
}) => (
  <ThemeProvider theme={theme}>
    <DeleteConfirmation
      open={show}
      title={title}
      subtitle={subtitle}
      deleteButtonText={deleteButtonText}
      cancelButtonText={cancelButtonText}
      onDelete={() => proceed(true)}
      onCancel={() => proceed(false)}
    />
  </ThemeProvider>
);

const ConfirmableDialog = confirmable(ResetScenarioConstraintsDialog);

export const confirmResetScenarioConstraints = createConfirmation(ConfirmableDialog);
